import { tierForReputation } from '../utils/reputation';
import { compactNumber } from '../utils/format';

// Inline rep counter pill — icon shell + count + (optional) tier
// title. Mirrors mobile's ReputationBadge in spirit. Sizes map to
// distinct typography (sm 11/sm pill, md 12/md pill, lg 14/lg pill).
export default function ReputationBadge({ value = 0, rewards, showTitle = false, size = 'sm' }) {
  const tier = tierForReputation(value);
  const color = rewards?.badge?.color || tier.color;
  const icon = tier.icon || '✦';

  const padding = size === 'lg' ? '6px 12px' : size === 'md' ? '4px 10px' : '3px 8px';
  const fontSize = size === 'lg' ? 14 : size === 'md' ? 12 : 11;

  return (
    <span
      className="row"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding,
        borderRadius: 999,
        border: `1px solid ${color.border}`,
        background: color.bg,
        color: color.fg,
        fontSize, fontWeight: 800, whiteSpace: 'nowrap'
      }}
    >
      <span style={{ fontSize: fontSize + 2, lineHeight: 1 }}>{icon}</span>
      <span>{compactNumber(value)}</span>
      {showTitle ? <span style={{ opacity: 0.85 }}>· {tier.title}</span> : null}
    </span>
  );
}
